// extracted by mini-css-extract-plugin
export default {"root":"seventh_root__wSn9o","top":"seventh_top__hJNQ3","title":"seventh_title__JYqnd","description":"seventh_description__QeuI9","bottom":"seventh_bottom__KuHNM"};